import { InsuranceFlowStatus } from '../insurance-flow/insurance-flow-status.enum';

export enum CancellationFlowStatus {
  PENDING = 'PENDING',
  LETTER_GENERATED = 'LETTER_GENERATED',
  SIGNED = 'SIGNED',
  SENT = 'SENT',
  CLOSED = 'CLOSED',
  CANCELLED = 'CANCELLED',
}

export const getCancellationFlowStatusLabel = (
  status: CancellationFlowStatus
): string => {
  switch (status) {
    case CancellationFlowStatus.PENDING:
      return $localize`Demande créée`;
    case CancellationFlowStatus.LETTER_GENERATED:
      return $localize`Lettre générée`;
    case CancellationFlowStatus.SIGNED:
      return $localize`Lettre signée`;
    case CancellationFlowStatus.SENT:
      return $localize`Lettre envoyée à l'assureur`;
    case CancellationFlowStatus.CLOSED:
      return $localize`Terminée`;
    case CancellationFlowStatus.CANCELLED:
      return $localize`Demande annulée`;
    default:
      return status;
  }
};

/** Over, one way or the other: nothing is linked to it any more. */
export const isCancellationFlowOver = (
  status: CancellationFlowStatus
): boolean =>
  status === CancellationFlowStatus.CLOSED ||
  status === CancellationFlowStatus.CANCELLED;

/**
 * Where a cancellation opened by mistake can still be taken back: before the
 * customer signed anything. Who filed it does not matter — unlike correcting
 * it, clearing a mistake is worth doing whatever its source.
 */
export const isCancellationFlowDeletable = (
  status: CancellationFlowStatus
): boolean =>
  status === CancellationFlowStatus.PENDING ||
  status === CancellationFlowStatus.LETTER_GENERATED;

/**
 * Where a linked replacement has got far enough for the insurer to be told:
 * in force, or about to take effect. Until then the letter waits for it.
 */
export const isReplacementReady = (status: InsuranceFlowStatus): boolean =>
  status === InsuranceFlowStatus.POLICY_ACTIVE ||
  status === InsuranceFlowStatus.PENDING_ACTIVATION;

/** The `lty-badge` modifier a status is drawn with in lists and pills. */
export const getCancellationFlowStatusClass = (
  status: CancellationFlowStatus
): string => {
  switch (status) {
    case CancellationFlowStatus.PENDING:
      return 'blue';
    case CancellationFlowStatus.LETTER_GENERATED:
      return 'warning';
    case CancellationFlowStatus.SIGNED:
      return 'sky';
    case CancellationFlowStatus.SENT:
      return 'zinc';
    case CancellationFlowStatus.CLOSED:
      return 'success';
    case CancellationFlowStatus.CANCELLED:
      return 'danger';
    default:
      return '';
  }
};
